<template>
  <side-bar-page :dataProps="{showUp: true,percentShow: 0}">
    <template slot="content">
        <div id="top">
            <!-- <button @click="test">test</button> -->
            <div class="openTree">
                <p>{{$t('vp_text1')}}</p>
                <b-link v-if="!isOpenTree" to="" @click="isOpenTree=true">
                    <!-- <i class="fa fa-plus-square" aria-hidden="true"></i> {{$t('showAllSections')}} -->
                    &#10148; {{$t('showAllSections')}}
                </b-link>
                <b-link v-if="isOpenTree" to="" @click="isOpenTree=false">
                    <!-- <i class="fa fa-minus-square" aria-hidden="true"></i> {{$t('hideAllSections')}} -->
                    &#x25BC; {{$t('hideAllSections')}}
                </b-link>
                <ul v-for="(item, index) in treeData" :key="index">
                    <tree-item
                        v-if="isOpenTree" 
                        class="item"
                        :item="item"
                        :selectHashTag="selectHashTag"
                        @select-item="setSelectItem"
                    ></tree-item>
                </ul>
            </div>
            <b-row v-if="isUploadsRequest" style="justify-content: center; margin-top: 10px;">
                <sync-loader class="text-center" color="red"></sync-loader>
            </b-row>
            <div v-if="this.videos.length && !isUploadsRequest" class="content content-m">
                <div class="row row-gallery-video">
                        <gallery 
                            :input="videos" 
                            :index="indexVideo"
                            :clickToPlay="false"
                            @close="indexVideo = null"
                        ></gallery>

                        <div class="col-md-3 custom-padding" v-for="(video, videoIndex) in videos" :key="videoIndex">
                            <div class="video gallery-image" @click="indexVideo = inputOver ? null : videoIndex"
                            :style="{ backgroundImage: 'url(' + video.poster + ')'}">
                                <div v-if="!isMobileResolution" class="overlay">
                                    <div v-if="isAdmin" @mouseover="inputOver = true" @mouseleave="inputOver = false">
                                        <input v-model="video.hashTag" @input="video.hashTagEdit = true" placeholder="Set hash tag"/>
                                        <button v-if="video.hashTagEdit" @click="saveHashTag(video)">save</button>
                                    </div>
                                    <div class="overlay-text">{{video.title}}</div>
                                </div>
                                <div v-if="isAdmin && isMobileResolution" @mouseover="inputOver = true" @mouseleave="inputOver = false">
                                    <input v-model="video.hashTag" @input="video.hashTagEdit = true" placeholder="Set hash tag"/>
                                    <button v-if="video.hashTagEdit" @click="saveHashTag(video)">save</button>
                                </div>
                            </div>
                        </div>
                </div>
                <b-pagination v-if="maxPage>1" v-model="currentPage" :total-rows="allVideosCount" :per-page="countPerPageS" size="md" align="center" @input="setPage"/>
            </div>
            <div v-if="firstLoadComplete && !this.videos.length && !isUploadsRequest" style="text-align: center;">{{$t('noFind')}}...</div>
        </div>
    </template>
  </side-bar-page>
</template>

<script>
  import SideBarPage from '../components/SideBarPage'
  import TreeItem from '../components/TreeItem'
  import { mapActions, mapGetters } from 'vuex';
  import {UPLOADS_LOAD_VIDEO,VIDEO_TREE_LOAD,UPLOADS_SAVE_HASH_TAG} from "../store/actions/userConst";
  import gallery from 'gallery-vue';
  import syncLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    name: 'videoPage',
    components: { SideBarPage, gallery, TreeItem, syncLoader },
    watch: {
      '$route'() {
        this.selectHashTag = this.$route.params.hashTag;
        this.loadVideos();
      }
    },
    data() {
        return {
            videos: [],
            inputOver: false,
            indexVideo: null,
            treeData: [],
            treeDataCopy: [],
            selectHashTag: '#AllVideos',
            maxPage: 0,
            currentPage: 1,
            countPerPage: 0,
            RxIsLoadProfilePointer: null,
            firstLoadComplete: false,
            isOpenTree: true
        }
    },
    beforeDestroy() {
        this.RxIsLoadProfilePointer.unsubscribe()
    },
   created() {
       if(this.$route.params.hashTag) this.selectHashTag = this.$route.params.hashTag;
        this.VIDEO_TREE_LOAD()
            .then(res=>{
                this.treeData = res;
                this.RxIsLoadProfilePointer = this.RxIsLoadProfile.subscribe(usr=> {
                    if(this.isAdmin && !~this.treeData.findIndex(t=>t.hashTag==="#AllVideosWithoutHashtag")) {
                        this.treeData.push({
                            name: "All videos without hashtag",
                            locales: [{
                                language: "ru",
                                name: "Все видео без хэштега"
                            }],
                            hashTag: "#AllVideosWithoutHashtag",
                            children: []
                        })
                        // this.treeData.push({
                        //     name: "All videos with hashtag",
                        //     locales: [{
                        //         language: "ru",
                        //         name: "Все видео с хэштегом"
                        //     }],
                        //     hashTag: "#AllVideosWithHashtag",
                        //     children: []
                        // })
                    }
                });
            })
            .catch(err=>console.log(err))
        this.loadVideos();
    },
    computed: {
        ...mapGetters(['RxIsLoadProfile','countPerPageS','isUploadsRequest','isAdmin','isMobileResolution'])
    },
    methods: {
        ...mapActions([UPLOADS_LOAD_VIDEO,VIDEO_TREE_LOAD,UPLOADS_SAVE_HASH_TAG]),
        saveHashTag(video) {
            this.UPLOADS_SAVE_HASH_TAG({id: video.id, data: {hashTag: video.hashTag}})
                .then(res=>{
                    delete video.hashTagEdit;
                    this.videos.push({})
                    this.videos.splice(this.videos.length-1,1)
                })
                .catch(err=>console.log(err));
        },
        setPage() {
            this.$scrollTo('#top', 1000, { container: '#scroll' });
            this.loadVideos();
        },
        loadVideos() {
            let par = {skip: (this.currentPage-1)*this.countPerPageS,limit: this.countPerPageS};
            switch (this.selectHashTag) {
                case '#AllVideos':
                    par.where = {hashTag: {$nin: [null,""]}};
                    break;
                case '#AllVideosWithoutHashtag':
                    par.where = {hashTag: {$in: [null,""]}};
                    break;
                // case '#AllVideosWithHashtag':
                //     par.where = {hashTag: {$nin: [null,""]}};
                //     break;
                default:
                    par.where = {hashTag: {regexp: `^${this.selectHashTag}`}};
                    break;
            }
            // if(this.selectHashTag!='#AllVideos') {
            //     if(this.selectHashTag=='#AllVideosWithoutHashtag') {
            //         par.where = {hashTag: {$in: [null,""]}};
            //     } else {
            //         par.where = {hashTag: {regexp: `^${this.selectHashTag}`}};
            //     }
            // } 
            this.UPLOADS_LOAD_VIDEO(par)
                .then(res=>{
                    this.videos = res.videos;
                    // hack for gallery
                    this.videos.forEach(element => {
                        element.type = "text/html";
                    });
                    this.allVideosCount = res.allVideosCount;
                    this.maxPage = parseInt(this.allVideosCount/this.countPerPageS) + ((this.allVideosCount % this.countPerPageS)?1:0)
                    this.firstLoadComplete = true;
                })
                .catch(err=>console.log(err))
        },
        setSelectItem(item) {
            // this.treeData = JSON.parse(JSON.stringify(this.treeDataCopy));
            if(this.selectHashTag != item.hashTag) {
                this.currentPage = 1; 
                this.$router.push({ name: 'videoPage', params: { hashTag :  item.hashTag} });
                // this.selectHashTag = item.hashTag;
                // this.loadVideos();
            }
        },
        test() {
            // this.$refs.TheBestShows.click();
            // console.log(JSON.stringify(this.videos[0]));
            // this.selectHashTag = '#TheBestShows#Musical';
            // this.isOpenTree=true;
            // this.loadVideos();
            console.log(this.$route.params.hashTag);
            console.log(this.selectHashTag);
       }
    }
  }
</script>

<style scoped lang="scss">
    .openTree {
        margin-left: 10px;
        color: #dd0000;
        >a {
            color: #dd0000;
            font-weight: 600;
            text-transform: uppercase;
            .fa {
                font-weight: bold;
                padding-right: 3px;
            }
        }
        >p {
            margin: 0 !important; 
            font-weight: bold;
        }
        >ul {
            margin: 0 !important;
            color: #547bff;
            font-weight: 600;
        }
    }
    .content {
        background-color:#F7F7F8 !important;
        min-height: 100%;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 25px;
    }
    .row-gallery-video {
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        min-height: 212px;
        background-size: 180px;
        background-repeat: no-repeat;
        background-position-x: 15px;
        background-position-y: 15px;
        padding-left: 10px;
        padding-top: 10px;
    }
    .video {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
    }
    .gallery-image {
            width: 100% !important;
            height: 190px;
            cursor: pointer;
            transition: all 0.3s;
    }
    .gallery-image:hover .overlay {
        height: 100%;
        width: 100%;
    }
    .pagination {
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .custom-padding {
        padding-left: 0;
        padding-right: 10px;
        padding-bottom: 10px;
    }
    @media only screen and (max-width: 768px) {
        .content {
            padding-top: 10px !important;
        }
        .gallery-image {
            width: 97% !important;
            height: 200px;
        }
        .video {
            margin-left: 10px;
        }
    }
    .overlay {
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        background-color: #008CBA;
        overflow: hidden;
        width: 100%;
        height: 0;
        transition: .5s ease;
        opacity: 0.7;
    }
    .overlay-text {
        color: white;
        font-size: 1.2rem;
        position: absolute;
        overflow: hidden;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        font-weight: 600;
        text-shadow: 1px 1px 1px black;
        text-align: center;
        white-space: normal;
        word-wrap: break-word;
        padding-left: 10px;
        padding-right: 10px;
        width: inherit;
    }
</style>
